import { Chip } from "@mui/material";
import { type MouseEvent } from "react";

// ToggleChip.tsx
// Kiro made this
interface ToggleChipProps {
  value: string | number;
  label: string;
  disabled?: boolean;
  // injected by ToggleChipGroup — not meant to be passed manually
  selected?: boolean;
  onChange?: (
    _event: MouseEvent<HTMLDivElement>,
    _value: string | number,
  ) => void;
}

export default function ToggleChip({
  value,
  label,
  disabled,
  selected,
  onChange,
}: ToggleChipProps) {
  return (
    <Chip
      label={label}
      clickable
      disabled={disabled}
      color={selected ? "primary" : "default"}
      variant={selected ? "filled" : "outlined"}
      onClick={(event) => onChange?.(event, value)}
    />
  );
}
